import { hasElements } from "utils/arrays";
import { add as _add, getAsync as _getAsync, update as _update, deleteAllAsync as _deleteAllAsync } from "../api";

const BASE_URL = "/calendar";

function normalizeEventData(event, sentPayload) {
    const { startDateTime: startDateTimeInMillis, endDateTime: endDateTimeInMillis, placeType } = event;

    const startDateTime = startDateTimeInMillis && new Date(startDateTimeInMillis);
    const endDateTime = endDateTimeInMillis && new Date(endDateTimeInMillis);
    const currentGuest = hasElements(event.guests) && event.guests.find((x) => x.guestEmail === sentPayload.email);
    const eventColor = currentGuest && currentGuest.eventColor;
    const isGuestGoing = currentGuest && currentGuest.going;
    const notificationInterval = event.notification && String(event.notification).split("-")[0];
    const notificationTimeUnit = event.notification && String(event.notification).split("-")[1];

    return {
        ...event,
        start: startDateTime,
        end: endDateTime,
        placeType: !placeType ? "none" : placeType,
        eventColor,
        going: isGuestGoing,
        notificationInterval,
        notificationTimeUnit,
    };
}
export function normalizeEvents(events, sentPayload) {
    return events.map((event) => normalizeEventData(event, sentPayload));
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export async function getMyEventsAsync({ data }) {
    return _getAsync({
        url: `${BASE_URL}/my-events`,
        normalizer: (events) => normalizeEvents(events, data),
        data,
    });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export async function deleteAsync({ data }) {
    return _deleteAllAsync({
        url: BASE_URL,
        data,
    });
}